// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"246":"3c33ef30","837":"545cee47"}[chunkId] + ".js";
};